// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__RdVeO","blog-link":"breadcrumbs_blog-link__FQ8yx","crumb":"breadcrumbs_crumb__zC2jQ","crumb-title":"breadcrumbs_crumb-title__SmxYU"};